import React from "react";


export const UserStatus = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8.49194C16.5877 8.49194 13.0081 12.0716 13.0081 16.4839C13.0081 20.8961 16.5877 24.4758 21 24.4758C25.4123 24.4758 28.9919 20.8961 28.9919 16.4839C28.9919 12.0716 25.4123 8.49194 21 8.49194ZM21 20.1048C19.001 20.1048 17.379 18.4829 17.379 16.4839C17.379 14.4848 19.001 12.8629 21 12.8629C22.999 12.8629 24.621 14.4848 24.621 16.4839C24.621 18.4829 22.999 20.1048 21 20.1048ZM21 0.75C9.81354 0.75 0.75 9.81354 0.75 21C0.75 32.1865 9.81354 41.25 21 41.25C32.1865 41.25 41.25 32.1865 41.25 21C41.25 9.81354 32.1865 0.75 21 0.75ZM21 36.879C17.1341 36.879 13.5959 35.4845 10.8401 33.1796C12.0064 31.5007 13.914 30.3719 16.0877 30.2916C17.7714 30.806 19.3802 31.0645 21 31.0645C22.6188 31.0645 24.2276 30.8142 25.9125 30.2917C28.0869 30.3797 29.9941 31.502 31.1599 33.1796C28.4041 35.4845 24.8659 36.879 21 36.879ZM16.3548 25.9113C12.9337 25.9113 9.91482 27.4907 7.89287 29.9307C6.14946 27.3854 5.12097 24.3111 5.12097 21C5.12097 12.2429 12.2429 5.12097 21 5.12097C29.7571 5.12097 36.879 12.2429 36.879 21C36.879 24.3109 35.8507 27.385 34.1075 29.9301C32.0926 27.4902 29.0735 25.9113 25.6452 25.9113C25.4049 25.9113 25.1443 25.9673 24.8669 26.0405C24.741 26.0738 24.6069 26.1119 24.4661 26.1519C24.45 26.1565 24.4338 26.1611 24.4175 26.1658C24.2581 26.2111 24.0887 26.2589 23.9065 26.3065C23.1806 26.4964 22.247 26.6855 21 26.6855C19.7571 26.6855 18.8235 26.4964 18.0965 26.3065C17.9139 26.2588 17.7443 26.211 17.5845 26.1657L17.5374 26.1524C17.3957 26.1122 17.2608 26.0739 17.1341 26.0405C16.8561 25.9673 16.595 25.9113 16.3548 25.9113Z"
      fill="#484848"
      stroke="#484848"
      stroke-width="0.5"
    />
  </svg>
);



export const User = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8.49194C16.5877 8.49194 13.0081 12.0716 13.0081 16.4839C13.0081 20.8961 16.5877 24.4758 21 24.4758C25.4123 24.4758 28.9919 20.8961 28.9919 16.4839C28.9919 12.0716 25.4123 8.49194 21 8.49194ZM21 20.1048C19.001 20.1048 17.379 18.4829 17.379 16.4839C17.379 14.4848 19.001 12.8629 21 12.8629C22.999 12.8629 24.621 14.4848 24.621 16.4839C24.621 18.4829 22.999 20.1048 21 20.1048ZM21 0.75C9.81354 0.75 0.75 9.81354 0.75 21C0.75 32.1865 9.81354 41.25 21 41.25C32.1865 41.25 41.25 32.1865 41.25 21C41.25 9.81354 32.1865 0.75 21 0.75ZM21 36.879C17.1341 36.879 13.5959 35.4845 10.8401 33.1796C12.0064 31.5007 13.914 30.3719 16.0877 30.2916C17.7714 30.806 19.3802 31.0645 21 31.0645C22.6188 31.0645 24.2276 30.8142 25.9125 30.2917C28.0869 30.3797 29.9941 31.502 31.1599 33.1796C28.4041 35.4845 24.8659 36.879 21 36.879ZM16.3548 25.9113C12.9337 25.9113 9.91482 27.4907 7.89287 29.9307C6.14946 27.3854 5.12097 24.3111 5.12097 21C5.12097 12.2429 12.2429 5.12097 21 5.12097C29.7571 5.12097 36.879 12.2429 36.879 21C36.879 24.3109 35.8507 27.385 34.1075 29.9301C32.0926 27.4902 29.0735 25.9113 25.6452 25.9113C25.4049 25.9113 25.1443 25.9673 24.8669 26.0405C24.741 26.0738 24.6069 26.1119 24.4661 26.1519C24.45 26.1565 24.4338 26.1611 24.4175 26.1658C24.2581 26.2111 24.0887 26.2589 23.9065 26.3065C23.1806 26.4964 22.247 26.6855 21 26.6855C19.7571 26.6855 18.8235 26.4964 18.0965 26.3065C17.9139 26.2588 17.7443 26.211 17.5845 26.1657L17.5374 26.1524C17.3957 26.1122 17.2608 26.0739 17.1341 26.0405C16.8561 25.9673 16.595 25.9113 16.3548 25.9113Z"
      fill="#484848"
      stroke="#484848"
      stroke-width="0.5"
    />
  </svg>
);

export const Bitly = (
  <svg
    width="42"
    height="42"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_208_76)">
      <path
        d="M271.979 442.917C243.958 443.375 223.542 434.375 222.271 409.896C221.75 400.729 221.896 390.938 222.312 385.063C225.167 349.313 250.083 323.604 275.021 318.604C305.896 312.479 326.167 326.521 326.167 366.729C326.167 393.875 318.667 442.104 272.208 442.917H271.875H271.979ZM248.396 0C110.833 0 0 110.354 0 254.667C0 329.542 40 401.792 96.3125 445.229C107.146 453.563 120.021 452.875 127.5 445.646C133.687 439.708 133.167 425.146 121.562 414.917C76.5625 375.625 45.4792 315.75 45.4792 255.854C45.4792 148.563 140.896 58.1458 248.396 58.1458C379.229 58.1458 449.146 164.437 449.146 254.604C449.146 309.813 422.271 376.271 373.604 418.646C373.917 418.646 383.875 399.021 383.875 360.646C383.875 295.438 342.708 259.896 294.708 259.896C260.062 259.896 239.146 272.354 225.125 283.896C225.125 257.396 226.062 207.813 226.062 207.813C226.062 175.063 214.812 148.854 174.604 148.229C151.479 147.917 134.354 158.5 123.771 182.542C120.021 191.625 121.271 201.625 129.062 205.979C135.312 209.729 145.937 206.938 150.854 200.062C154.292 195.687 156.146 194.771 159.271 195.063C164.271 195.688 164.625 203.5 164.625 208.813C164.917 212.833 168.646 269.292 166.458 414.333C166.25 454.125 197.771 500 272.917 500C305.417 500 330.333 490.937 366.521 470.375C421.729 439.167 500 369.958 500 252.667C500.104 219.564 493.682 186.765 481.101 156.146C468.519 125.527 450.026 97.688 426.677 74.2216C403.329 50.7552 375.584 32.1215 345.028 19.3859C314.473 6.65035 281.707 0.0628117 248.604 0"
        fill="#484848"
      />
    </g>
  </svg>
);

export const Savemessage = (
  <svg
    width="32"
    height="44"
    viewBox="0 0 32 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 4.25V38.375L13.0719 30.7156C13.903 30.0508 14.9357 29.6886 16 29.6886C17.0643 29.6886 18.097 30.0508 18.9281 30.7156L28.5 38.3719V4.25H3.5ZM1.9375 1.125H30.0625C30.4769 1.125 30.8743 1.28962 31.1674 1.58265C31.4604 1.87567 31.625 2.2731 31.625 2.6875V41.625C31.6246 41.919 31.5412 42.2069 31.3845 42.4557C31.2278 42.7045 31.004 42.904 30.739 43.0312C30.474 43.1585 30.1784 43.2085 29.8862 43.1753C29.5941 43.1421 29.3172 43.0272 29.0875 42.8438L16.975 33.1562C16.6981 32.9352 16.3543 32.8147 16 32.8147C15.6457 32.8147 15.3019 32.9352 15.025 33.1562L2.9125 42.8438C2.68275 43.0272 2.4059 43.1421 2.11376 43.1753C1.82162 43.2085 1.52605 43.1585 1.26102 43.0312C0.995987 42.904 0.772249 42.7045 0.615517 42.4557C0.458785 42.2069 0.375419 41.919 0.375 41.625V2.6875C0.375 2.2731 0.53962 1.87567 0.832646 1.58265C1.12567 1.28962 1.5231 1.125 1.9375 1.125Z"
      fill="#484848"
      stroke="#484848"
      stroke-width="0.5"
    />
  </svg>
);

export const Message = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66675 35V13.3334C6.66675 12.0073 7.19353 10.7355 8.13121 9.79784C9.0689 8.86016 10.3407 8.33337 11.6667 8.33337H28.3334C29.6595 8.33337 30.9313 8.86016 31.8689 9.79784C32.8066 10.7355 33.3334 12.0073 33.3334 13.3334V23.3334C33.3334 24.6595 32.8066 25.9312 31.8689 26.8689C30.9313 27.8066 29.6595 28.3334 28.3334 28.3334H13.3334L6.66675 35Z"
      stroke="#484848"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 15H26.6666"
      stroke="#484848"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 21.6666H23.3333"
      stroke="#484848"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Url = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_210_84)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.7248 6.04419L14.2748 0.311157C14.0858 0.113157 13.8238 0.000244141 13.5498 0.000244141H1.99976C0.895756 0.000244141 -0.000244141 0.896244 -0.000244141 2.00024V9.00024C-0.000244141 9.55224 0.447756 10.0002 0.999756 10.0002C1.55276 10.0002 1.99976 9.55224 1.99976 9.00024V3.00024C1.99976 2.44824 2.44776 2.00024 2.99976 2.00024H11.9998V6.00024C11.9998 7.10524 12.8958 8.00024 13.9998 8.00024H17.9998V9.00024C17.9998 9.55224 18.4478 10.0002 18.9998 10.0002C19.5528 10.0002 19.9998 9.55224 19.9998 9.00024V6.73315C19.9998 6.47715 19.9018 6.23019 19.7248 6.04419ZM10.9998 15.0002C10.9998 14.4482 10.5528 14.0002 9.99976 14.0002H8.99976V16.0002H9.99976C10.5528 16.0002 10.9998 15.5532 10.9998 15.0002ZM11.7248 17.4492L12.3558 18.7122C12.6518 19.3042 12.2218 20.0002 11.5598 20.0002H11.5498C11.2128 20.0002 10.9048 19.8102 10.7538 19.5082L9.99976 18.0002H8.99976V19.1102C8.99976 19.6022 8.60176 20.0002 8.10976 20.0002H7.88976C7.39876 20.0002 6.99976 19.6022 6.99976 19.1102V12.8903C6.99976 12.3993 7.39876 12.0002 7.88976 12.0002H9.85275C11.4148 12.0002 12.8238 13.1302 12.9838 14.6842C13.1018 15.8262 12.5738 16.8502 11.7248 17.4492ZM18.9998 18.0002H16.4998C16.2238 18.0002 15.9998 17.7762 15.9998 17.5002V13.0002C15.9998 12.4482 15.5528 12.0002 14.9998 12.0002C14.4478 12.0002 13.9998 12.4482 13.9998 13.0002V18.0002V19.0002C13.9998 19.5522 14.4478 20.0002 14.9998 20.0002H15.9998H18.9998C19.5528 20.0002 19.9998 19.5522 19.9998 19.0002C19.9998 18.4482 19.5528 18.0002 18.9998 18.0002ZM5.99976 12.8903V17.0002C5.99976 18.7112 4.56875 20.0872 2.83875 19.9962C1.21675 19.9112 -0.000244141 18.4552 -0.000244141 16.8302V12.8903C-0.000244141 12.3993 0.398755 12.0002 0.889755 12.0002H1.10976C1.60176 12.0002 1.99976 12.3993 1.99976 12.8903V17.0002C1.99976 17.5522 2.44776 18.0002 2.99976 18.0002C3.55276 18.0002 3.99976 17.5522 3.99976 17.0002V12.8903C3.99976 12.3993 4.39876 12.0002 4.88976 12.0002H5.10976C5.60176 12.0002 5.99976 12.3993 5.99976 12.8903Z"
        fill="#484848"
      />
    </g>
  </svg>
);

export const Thumbnail = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.1645 19.9977 17.3284 19.981 17.49 19.95L17.79 19.88H17.86H17.91L18.28 19.74L18.41 19.67C18.51 19.61 18.62 19.56 18.72 19.49C18.8535 19.3918 18.9805 19.2849 19.1 19.17L19.17 19.08C19.2682 18.9805 19.3585 18.8735 19.44 18.76L19.53 18.63C19.5998 18.5187 19.6601 18.4016 19.71 18.28C19.7374 18.232 19.7609 18.1818 19.78 18.13C19.83 18.01 19.86 17.88 19.9 17.75V17.6C19.9567 17.4046 19.9903 17.2032 20 17V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0ZM3 18C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V12.69L5.29 9.39C5.38296 9.29627 5.49356 9.22188 5.61542 9.17111C5.73728 9.12034 5.86799 9.0942 6 9.0942C6.13201 9.0942 6.26272 9.12034 6.38458 9.17111C6.50644 9.22188 6.61704 9.29627 6.71 9.39L15.31 18H3ZM18 17C17.9991 17.1233 17.9753 17.2453 17.93 17.36C17.9071 17.4087 17.8804 17.4556 17.85 17.5C17.8232 17.5423 17.7931 17.5825 17.76 17.62L12.41 12.27L13.29 11.39C13.383 11.2963 13.4936 11.2219 13.6154 11.1711C13.7373 11.1203 13.868 11.0942 14 11.0942C14.132 11.0942 14.2627 11.1203 14.3846 11.1711C14.5064 11.2219 14.617 11.2963 14.71 11.39L18 14.69V17ZM18 11.86L16.12 10C15.5477 9.45699 14.7889 9.15428 14 9.15428C13.2111 9.15428 12.4523 9.45699 11.88 10L11 10.88L8.12 8C7.54772 7.45699 6.7889 7.15428 6 7.15428C5.2111 7.15428 4.45228 7.45699 3.88 8L2 9.86V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V11.86ZM11.5 4C11.2033 4 10.9133 4.08797 10.6666 4.2528C10.42 4.41762 10.2277 4.65189 10.1142 4.92597C10.0006 5.20006 9.97094 5.50166 10.0288 5.79264C10.0867 6.08361 10.2296 6.35088 10.4393 6.56066C10.6491 6.77044 10.9164 6.9133 11.2074 6.97118C11.4983 7.02906 11.7999 6.99935 12.074 6.88582C12.3481 6.77229 12.5824 6.58003 12.7472 6.33335C12.912 6.08668 13 5.79667 13 5.5C13 5.10218 12.842 4.72064 12.5607 4.43934C12.2794 4.15804 11.8978 4 11.5 4Z"
      fill="#484848"
    />
  </svg>
);

export const Pin = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.4 18L9 16.6L0 25.6V27H1.4L10.4 18Z" fill="#484848" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.4654 0.55127L26.4141 9.49996L25.707 10.2071C24.4119 11.5021 22.611 12.1317 20.8321 11.882L17.4244 15.2896C18.0685 17.8825 17.4248 20.7892 15.307 22.9071L14.5999 23.6142L3.28564 12.3L3.99275 11.5928C5.90843 9.67717 8.60434 8.95297 11.08 9.40561L15.0132 5.47243C15.1062 3.97939 15.6872 2.50727 16.7599 1.32728L17.4654 0.55127ZM17.6181 3.53242C17.2065 4.26158 16.9999 5.07929 16.9999 5.89996V6.31417L11.7018 11.6122L11.1474 11.4676C9.48107 11.0329 7.63398 11.3343 6.17509 12.361L14.5428 20.7286C15.7075 19.1073 15.942 17.0886 15.3512 15.3162L15.1557 14.7299L20.1931 9.69249L20.7424 9.82981C21.67 10.0617 22.6551 9.90685 23.4966 9.41088L17.6181 3.53242Z"
      fill="#484848"
    />
  </svg>
);

export const Media = (
  <svg
    width="36"
    height="40"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1V5C6 5.26522 5.89464 5.51957 5.7071 5.70711C5.51957 5.89464 5.26521 6 5 6H0.999998M15 18C15.0081 18.2561 14.9145 18.505 14.7397 18.6924C14.5649 18.8798 14.3231 18.9904 14.067 19H1.933C1.67693 18.9904 1.43508 18.8798 1.26027 18.6924C1.08546 18.505 0.991891 18.2561 0.999998 18V5.828C1.00011 5.29761 1.2109 4.78899 1.586 4.414L4.414 1.586C4.78898 1.2109 5.29761 1.00011 5.828 1H14.067C14.3231 1.00965 14.5649 1.12023 14.7397 1.30759C14.9145 1.49495 15.0081 1.74388 15 2V18ZM11.045 7.514C11.045 7.64661 10.9923 7.77379 10.8986 7.86755C10.8048 7.96132 10.6776 8.014 10.545 8.014C10.4124 8.014 10.2852 7.96132 10.1914 7.86755C10.0977 7.77379 10.045 7.64661 10.045 7.514C10.045 7.38139 10.0977 7.25421 10.1914 7.16045C10.2852 7.06668 10.4124 7.014 10.545 7.014C10.6776 7.014 10.8048 7.06668 10.8986 7.16045C10.9923 7.25421 11.045 7.38139 11.045 7.514ZM3.857 15.92L6.473 10.587L8.385 15.267L9.995 12.55L11.805 15.92H3.857Z"
      stroke="#484848"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Link = (
  <svg
    width="45"
    height="42"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 7V6.8C18 5.11984 18 4.27976 17.673 3.63803C17.3854 3.07354 16.9265 2.6146 16.362 2.32698C15.7202 2 14.8802 2 13.2 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H10.5M10.5 11H6M9.5 15H6M14 7H6M16 18V12.5C16 11.6716 16.6716 11 17.5 11C18.3284 11 19 11.6716 19 12.5V18C19 19.6569 17.6569 21 16 21C14.3431 21 13 19.6569 13 18V14"
      stroke="#484848"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Voice = (
  <svg
    width="45"
    height="45"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9.85986V14.1499"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 8.42993V15.5699"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 14.99V17"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 7V11.95"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 8.42993V15.5699"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 9.85986V14.1499"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 12.99V15C2 20 4 22 9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9"
      stroke="#484848"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Logo = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_567_6699)">
      <path
        d="M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z"
        fill="white"
      />
      <path
        d="M33.75 17.5C33.75 26.4746 26.4746 33.75 17.5 33.75C8.52537 33.75 1.25 26.4746 1.25 17.5C1.25 8.52537 8.52537 1.25 17.5 1.25C26.4746 1.25 33.75 8.52537 33.75 17.5Z"
        stroke="#A370CE"
        stroke-opacity="0.5"
        stroke-width="2.5"
      />
      <path
        d="M25.1963 15.3125C19.3795 12.3574 12.7693 17.7884 15.792 22.7699C17.196 25.1085 20.4355 26.5861 24.2676 25.4784C25.0352 25.7747 25.7173 26.258 26.4551 26.6179C26.2562 25.9696 26.0574 25.3313 25.8406 24.6949C29.806 21.875 28.9389 17.2156 25.1963 15.3125ZM20.5528 18.6733C20.4995 18.8142 20.4115 18.9394 20.2971 19.0374C20.1827 19.1354 20.0455 19.2031 19.8981 19.2343C19.7506 19.2654 19.5978 19.259 19.4535 19.2156C19.3092 19.1722 19.1781 19.0933 19.0723 18.986C18.9665 18.8787 18.8894 18.7466 18.848 18.6017C18.8066 18.4569 18.8023 18.3039 18.8355 18.157C18.8686 18.01 18.9382 17.8737 19.0378 17.7607C19.1374 17.6476 19.2638 17.5614 19.4054 17.51C20.0756 17.2276 20.8472 18.0031 20.5528 18.6733ZM24.906 18.7588H24.9179C24.853 18.8839 24.7601 18.9923 24.6463 19.0755C24.5326 19.1587 24.4011 19.2144 24.2622 19.2383C24.1234 19.2622 23.9808 19.2536 23.8458 19.2132C23.7108 19.1728 23.587 19.1017 23.4841 19.0054C23.3218 18.8148 23.214 18.584 23.1719 18.3372C23.2653 17.9176 23.5537 17.4841 24.019 17.4642C24.6594 17.3747 25.2341 18.1702 24.906 18.7588Z"
        fill="#A370CE"
      />
      <path
        d="M22.4322 14.0955C22.0344 12.1426 20.6702 10.4941 18.952 9.54349H18.9759C12.8748 6.09519 5.28016 10.9037 6.74778 16.5733C7.14551 18.2557 8.30488 19.6676 9.71681 20.6083C9.44437 21.3858 9.18386 22.1614 8.93926 22.9429C9.82619 22.4776 10.7151 21.9904 11.604 21.5171C12.6788 21.8656 13.8057 22.0258 14.935 21.9904C13.5429 17.9733 17.1225 13.7176 22.4322 14.0955ZM16.9037 11.7628C17.0755 11.7006 17.2598 11.6812 17.4407 11.7064C17.6216 11.7316 17.7937 11.8006 17.9418 11.9074C18.09 12.0143 18.2099 12.1557 18.2909 12.3193C18.372 12.483 18.4119 12.664 18.4072 12.8466V12.8585C18.4072 13.7355 17.2458 14.2844 16.5895 13.6898C15.9094 13.1986 16.1083 12.0094 16.9037 11.7628ZM12.8887 13.0813C12.7316 13.8449 11.7134 14.2128 11.1168 13.6997C10.4248 13.2105 10.6197 11.9995 11.431 11.7529C12.2265 11.4446 13.1293 12.256 12.8887 13.0813Z"
        fill="#1B5BFF"
      />
    </g>
 
  </svg>
);
